/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';
import {
  conformAmount,
  conformCount,
  formatAmount,
} from 'linced-app/utils/finance';

export default class CashReconciliation extends Component {
  entity = null;
  title = 'School Use Only (Cash Reconciliation)';
  readOnly = false;

  countInputOptions = Object.freeze({
    inputmode: 'numeric',
    pattern: '\\d*',
    size: 5,
    autocomplete: 'off',
  });

  amountInputOptions = Object.freeze({
    inputmode: 'decimal',
    pattern: '^\\d+(\\.\\d{1,2})?$',
    size: 8,
    autocomplete: 'off',
  });

  @action
  setCount(denomination, count) {
    this.entity.set(`${denomination}Count`, conformCount(count));
  }

  @action
  setCoinsAmount(amount) {
    this.entity.set('coinsAmount', conformAmount(amount));
  }

  @action
  formatAmount(propName) {
    this.set(propName, formatAmount(this.get(propName)));
  }
}
